export default () => ({
  periods      : [],
  periodsCombo : [],
  alertRemove  : true,
  period       : {},
  overlay      : true
});
